import React, { useState, useEffect, SetStateAction } from "react";
import Select, { components, CSSObjectWithLabel, InputProps } from "react-select";
import { TargetTypeOption } from "@ts/multi-select-dropdown";
import * as Sentry from "@sentry/react";
import $ from "jquery";
import { SelectOptions } from "@ts/common-types";

const Input = (props: InputProps<TargetTypeOption, true>) => {
    return <components.Input {...props} />;
};

interface IProps {
    options?: readonly TargetTypeOption[];
    placeholder: string;
    setSelectedOptions: React.Dispatch<SetStateAction<SelectOptions[]>>;
    targetSelected?: {
        value: string;
    }[];
    type?: string;
    setCampaignField?: (field: string, value: string) => void;
    isInvalid?: boolean;
}

const MultiSelectDropDown: React.FC<IProps> = (props) => {
    const [targetClassOptions, setTargetClassOptions] =
        useState<SelectOptions[]>();

    useEffect(() => {
        /**
         * ! This logic is responsible for changing options in create campaigns modal.
         */

        try {
            if (props.targetSelected) {
                if (props.targetSelected.length === 1) {
                    if (props.targetSelected[0].value === "product") {
                        setTargetClassOptions([
                            { value: "branded", label: "Branded" },
                            { value: "competition", label: "Competition" },
                        ]);
                    } else if (props.targetSelected[0].value === "keyword") {
                        setTargetClassOptions([
                            { value: "branded", label: "Branded" },
                            { value: "competition", label: "Competition" },
                            { value: "generic", label: "Generic" },
                        ]);
                    } else {
                        setTargetClassOptions([
                            { value: "auto", label: "Auto" },
                        ]);
                    }
                } else if (props.targetSelected.length === 2) {
                    if (
                        (props.targetSelected[0].value === "product" ||
                            props.targetSelected[0].value === "keyword") &&
                        (props.targetSelected[1].value === "product" ||
                            props.targetSelected[1].value === "keyword")
                    ) {
                        setTargetClassOptions([
                            { value: "branded", label: "Branded" },
                            { value: "competition", label: "Competition" },
                            { value: "generic", label: "Generic" },
                        ]);
                    } else if (
                        (props.targetSelected[0].value === "product" ||
                            props.targetSelected[0].value === "auto") &&
                        (props.targetSelected[1].value === "product" ||
                            props.targetSelected[1].value === "auto")
                    ) {
                        setTargetClassOptions([
                            { value: "branded", label: "Branded" },
                            { value: "competition", label: "Competition" },
                            { value: "auto", label: "Auto" },
                        ]);
                    } else if (
                        (props.targetSelected[0].value === "keyword" ||
                            props.targetSelected[0].value === "auto") &&
                        (props.targetSelected[1].value === "keyword" ||
                            props.targetSelected[1].value === "auto")
                    ) {
                        setTargetClassOptions([
                            { value: "branded", label: "Branded" },
                            { value: "competition", label: "Competition" },
                            { value: "generic", label: "Generic" },
                            { value: "auto", label: "Auto" },
                        ]);
                    }
                } else if (props.targetSelected.length === 3) {
                    setTargetClassOptions([
                        { value: "branded", label: "Branded" },
                        { value: "competition", label: "Competition" },
                        { value: "generic", label: "Generic" },
                        { value: "auto", label: "Auto" },
                    ]);
                } else {
                    setTargetClassOptions([]);
                }
            }
        } catch (err) {
            console.error(err);
            Sentry.captureException(err);
        }
    }, [props.targetSelected]);

    // TODO issue with typing and code discuss with nijo for refactoring
    const handleChange = (options: any) => {
        if (props.type && props.type === "campaignType") {
            const campaignTypes = options.map(
                ({ value }: { value: string }) => value
            );
            if (campaignTypes.includes("sb")) {
                $("#brand-info").show();
            } else {
                $("#brand-info").hide();
            }
        }
        props.setSelectedOptions(options);
        options.length
            ? $(`#${props.type}-validate`).hide()
            : $(`#${props.type}-validate`).show();
        props.setCampaignField(props.type, options);
    };

    return (
        <>
            <Select
                closeMenuOnSelect={false}
                placeholder={props.placeholder}
                styles={{
                    placeholder: (base: CSSObjectWithLabel) => ({
                        ...base,
                        fontSize: "1rem",
                    } as CSSObjectWithLabel),
                }}
                components={{ Input }}
                isMulti
                options={
                    props.targetSelected ? targetClassOptions : props.options
                }
                onChange={handleChange}
            />
            {
                <span
                    id={`${props.type}-validate`}
                    className="text-danger"
                    style={{ display: "none" }}
                >
                    {`Please select ${props.type}`}{" "}
                </span>
            }
        </>
    );
};

export default MultiSelectDropDown;
